import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { Shell } from './layout/Shell';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ApplicantWorkbench } from './workbenches/ApplicantHome';
import { CerWorkbench } from './workbenches/CerHome';
import { ParticipantWorkbench } from './workbenches/ParticipantHome';
import type { Workbench } from '@regigov/contracts';

function RequireWorkbench({ workbench, children }: { workbench: Workbench; children: JSX.Element }) {
  const { status, user } = useAuth();
  if (status === 'loading') return <p className="muted">Loading…</p>;
  if (status !== 'authenticated' || !user) return <Navigate to="/login" replace />;
  if (user.workbench !== workbench) return <Navigate to={`/${user.workbench}`} replace />;
  return children;
}

export function App() {
  const { status, user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={status === 'authenticated' && user ? <Navigate to={`/${user.workbench}`} replace /> : <LoginPage />} />
      <Route path="/register" element={status === 'authenticated' && user ? <Navigate to={`/${user.workbench}`} replace /> : <RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route element={<Shell />}>
        <Route
          path="/cer/*"
          element={
            <RequireWorkbench workbench="cer">
              <CerWorkbench />
            </RequireWorkbench>
          }
        />
        <Route
          path="/participant/*"
          element={
            <RequireWorkbench workbench="participant">
              <ParticipantWorkbench />
            </RequireWorkbench>
          }
        />
        <Route
          path="/applicant/*"
          element={
            <RequireWorkbench workbench="applicant">
              <ApplicantWorkbench />
            </RequireWorkbench>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={status === 'authenticated' && user ? `/${user.workbench}` : '/login'} replace />} />
    </Routes>
  );
}
